module.exports = function() {
  return new Worker(__webpack_public_path__ + "11c9f92a887508bc421b.worker.js");
};